// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-table-pdf {
  height: fit-content;
  width: 98%;
  margin-top: 0.5cm;
  margin-bottom: 0.5cm;
}
.wallet-table-pdf__title {
  font-size: 0.5cm;
  font-weight: 800;
  padding-left: 0.5cm;
  text-align: start;
  margin-bottom: 0.2cm;
}
.wallet-table-pdf__disclaimer {
  text-align: start;
  font-size: 0.25cm;
  padding-left: 0.5cm;
}
.wallet-table-pdf__content {
  height: 100%;
  width: 95%;
  font-size: 0.2cm;
  padding-left: 0.5cm;
}
.wallet-table-pdf__content .achat-vente-table {
  overflow-x: auto;
}
.wallet-table-pdf__content table {
  border-collapse: collapse;
  width: 100%;
}
.wallet-table-pdf__content th,
.wallet-table-pdf__content td {
  border: 0.0625rem solid #ddd;
  padding: 0.1cm;
  text-align: left;
  width: fit-content;
  text-wrap: wrap;
  height: 0.5cm;
  font-size: 0.3cm;
}
.wallet-table-pdf__content th:last-child,
.wallet-table-pdf__content td:last-child {
  text-wrap: wrap;
}
.wallet-table-pdf__content th:not(:first-child) {
  background-color: #4babb9;
  color: white;
}
.wallet-table-pdf__content .asset {
  font-weight: bold;
  color: white;
}
.wallet-table-pdf__content .bold {
  font-weight: bold;
  color: black;
}
.wallet-table-pdf__content a {
  color: black;
}
.wallet-table-pdf__content .action {
  background-color: #4babb9;
}
.wallet-table-pdf__content .obligations {
  background-color: #ef936c;
}
.wallet-table-pdf__content .monetaire {
  background-color: #031280;
}
.wallet-table-pdf__content .diversifie {
  background-color: #d0cece;
}`, "",{"version":3,"sources":["webpack://./src/features/pdf/components/wallet-table-pdf/wallet-table-pdf.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;AACD;AAAC;EACG,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAEJ;AAAE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;AAAE;EACI,YAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AAEN;AADM;EACI,gBAAA;AAGV;AAAQ;EACE,yBAAA;EACA,WAAA;AAEV;AACQ;;EAEE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AACV;AAAU;;EACE,eAAA;AAGZ;AAEQ;EACE,yBAAA;EACA,YAAA;AAAV;AAEQ;EACE,iBAAA;EACA,YAAA;AAAV;AAEQ;EACE,iBAAA;EACA,YAAA;AAAV;AAGQ;EACE,YAAA;AADV;AAGQ;EACA,yBAAA;AADR;AAGQ;EACA,yBAAA;AADR;AAGQ;EACA,yBAAA;AADR;AAGQ;EACE,yBAAA;AADV","sourcesContent":[".wallet-table-pdf{\n height: fit-content;\n width: 98%;\n margin-top: 0.5cm;\n margin-bottom: 0.5cm;\n &__title{\n    font-size: 0.5cm;\n    font-weight: 800;\n    padding-left: 0.5cm;\n    text-align: start;\n    margin-bottom: 0.2cm;\n  }\n  &__disclaimer{\n    text-align: start;\n    font-size: 0.25cm;\n    padding-left: 0.5cm;\n}\n  &__content{\n      height: 100%;\n      width: 95%;\n      font-size: 0.2cm;\n      padding-left: 0.5cm;\n      .achat-vente-table {\n          overflow-x: auto;\n        }\n        \n        table {\n          border-collapse: collapse;\n          width: 100%;\n        }\n        \n        th,\n        td {\n          border: 0.0625rem solid #ddd;\n          padding: 0.1cm;\n          text-align: left;\n          width: fit-content;\n          text-wrap: wrap;\n          height: 0.5cm;\n          font-size: 0.3cm;\n          &:last-child {\n            text-wrap: wrap;\n          }\n          \n        }\n\n        th:not(:first-child) {\n          background-color: #4babb9;\n          color: white;\n        }\n        .asset{\n          font-weight: bold;\n          color: white;\n        }\n        .bold {\n          font-weight: bold;\n          color:black;\n         \n        }\n        a{\n          color: black;\n        }\n        .action{\n        background-color: #4babb9;\n        }\n        .obligations{\n        background-color: #ef936c;\n        }\n        .monetaire{\n        background-color: #031280;\n        }\n        .diversifie{\n          background-color: #d0cece;\n        }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
